import Backbone from 'backbone';
import config from '../config/config';

const abl = {
	config: config,

	convertString: function(str) {
		if(str) {
			if(str.toLowerCase() === 'true') {
				str = true;
			}
			else if(str.toLowerCase() === 'false') {
				str = false;
			}
			else if(!isNaN(str)) {
				str = JSON.parse(str);
			}
		}

		return str;
	},

	createClass: function(members){
		const initialize = members.initialize || function() {};
		delete members.initialize;
		
		Object.keys(members).forEach(member => {
			initialize.prototype[member] = members[member];
		});

		return initialize;
	},

	setRouter: function(router) {
		Backbone.history.start()
		this.currentRouter = router;
	},

	navigate: function(url, updateHref, trigger){
		this.currentRouter.navigate(url, {trigger: trigger, replace: updateHref});
	}
};

export default abl;


/** WEBPACK FOOTER **
 ** ./src/js/abl.js
 **/